import Swiper from "../js/vendor/swiper/swiper.min";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tooltip";
import "../styles/page-obituary.scss";
import "../js/vendor/isotope.pkgd.min";
import { loader } from "./scripts/loader";
import { ensureIdaOkOrShowModal } from "./systems-status";

const memoriesList = {
  grid: null,
  loadMoreButton: $("#moreMemories"),
  orderSelect: $("#memories-order-select"),
  init: function () {
    this.loadList();
    this.initEvents();
  },
  loadList: function (newSearch = true) {
    const $this = this;
    const wrapper = $("#memories-list");
    const memorialId = parseInt($("#main").data("memorial-id"));

    if (newSearch === true) {
      $this.resetLoadMoreButton();
    }

    let filter = {
      order: $this.orderSelect.val(),
      page: $this.loadMoreButton.data("page"),
    };

    $.ajax({
      url: `/api/memorials/${memorialId}/memories/`,
      type: "POST",
      data: filter,
      dataType: "json",
      beforeSend: function () {
        loader.show();
      },
      success: function (result) {
        if (result.success) {
          const list = result.list;
          const html = list.reduce((acc, item) => {
            return acc + $this.renderMemoryTemplate(item);
          }, "");
          const imagesList = [];
          list.map((i) => {
            if (i.image !== "") {
              imagesList.push(i.image);
            }
          });

          const renderHtmlAndInitGrid = () => {
            if (newSearch === true) {
              wrapper.html(
                `<div class="grid-sizer"></div><div class="gutter-sizer"></div>${html}`
              );
            } else {
              wrapper.append(html);
            }
          };

          const initGrid = () => {
            setTimeout(() => {
              $this.initMasonryGrid();
              $(".single-obituary__transparent").removeClass(
                "single-obituary__transparent"
              );
              loader.hide();
            }, 100);
          };

          if (imagesList.length > 0) {
            renderHtmlAndInitGrid();
            loadImages(imagesList).then((results) => {
              initGrid();
            });
          } else {
            renderHtmlAndInitGrid();
            initGrid();
          }

          if (result.nextPage === false || list.length === 0) {
            $this.disableLoadMoreButton();
          }
        } else {
          loader.hide();
        }
      },
    });
  },
  disableLoadMoreButton: function () {
    this.loadMoreButton.addClass("disabled").hide();
  },
  updateLoadMoreButton: function () {
    const page = parseInt(this.loadMoreButton.data("page"), 10);
    this.loadMoreButton.data("page", page + 1);
  },
  resetLoadMoreButton: function () {
    this.loadMoreButton.data("page", 1).removeClass("disabled").show();
  },
  initMasonryGrid: function () {
    const currentScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    if (this.grid) {
      this.grid.isotope("destroy");
    }
    this.grid = $(".obituary-grid").isotope({
      itemSelector: ".single-obituary",
      masonry: {
        columnWidth: ".grid-sizer",
        gutter: ".gutter-sizer",
      },
      percentPosition: true,
    });
    $("html, body").animate({ scrollTop: currentScrollTop + "px" });
  },
  initEvents: function () {
    const $this = this;
    $this.loadMoreButton.click(function () {
      if ($(this).hasClass("disabled")) {
        return false;
      }

      $this.updateLoadMoreButton();
      $this.loadList(false);
    });

    this.orderSelect.on("change", function () {
      $this.updateLoadMoreButton();
      $this.loadList(true);
    });

    $("#memories-list").on(
      "click",
      ".single-obituary__resize-wrapper, .single-obituary__gallery-wrapper",
      function () {
        loader.show();
        const modalTpl = `
            <div class="modal fade" role="dialog" id="imgmodal" style="opacity: 0;">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">
                        <div class="swiper-container modal-swiper">
                            <div class="swiper-wrapper"></div>
                        </div>
                        <div class="swiper-button-prev"></div>
                        <div class="swiper-button-next"></div>
                    </div>
                </div>
            </div>`;
        $("body").append(modalTpl);

        const img = JSON.parse(
          $(this).closest(".single-obituary__image-wrapper").attr("data-slider")
        );
        const modalSlider = {};
        let timer;
        loadImages(img).then((results) => {
          results.forEach((element) => {
            $("#imgmodal .swiper-wrapper").append(
              `<div class="swiper-slide memory-slide"><img src='${element.value}' alt=""></div>`
            );
          });

          $("#imgmodal").modal("show");
          timer = setTimeout(() => {
            modalSlider.swiperModal = new Swiper(".modal-swiper", {
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
              slidesPerView: 1,
              direction: "horizontal",
              loop: false,
              on: {
                init: function () {
                  loader.hide();
                  $("#imgmodal").css("opacity", "1");
                  $(".modal-backdrop").css("opacity", ".5");
                },
              },
            });
          }, 300);
          $("#imgmodal").on("hidden.bs.modal", function (e) {
            $("#imgmodal").remove();
            clearTimeout(timer);
          });
        });
      }
    );
    $("#memories-list").on("click", ".abuse-report", async function () {
      if (!(await ensureIdaOkOrShowModal())) {
        return;
      }
      const memoryId = parseInt($(this).data("id"));
      const modalTpl = `
            <div class="modal fade obituary-modal" id="abuseReport" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div></div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_close.svg" alt="close icon">
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="modal-body__icon">
                                <img class="modal-body__icon" src="/wp-content/themes/fenix4/dist/images/icons/icon_warning-blue.svg" alt="Warning icon">
                            </div>
            
                            <div class="modal-body__abuse-title">Berätta varför du vill anmäla detta inlägg.</div>
                            <textarea class="modal-body__abuse-textarea" name="abuse-text" id="abuse-text" cols="55" rows="7" placeholder="Ditt meddelande..."></textarea>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary btn-white btn-white--border" data-dismiss="modal">Avbryt</button>
                            <button type="button" class="btn btn-primary btn-blue" id="submit-abuse-report">Skicka</button>
                        </div>
                    </div>
                </div>
            </div>
            `;
      $("body").append(modalTpl);

      const modal = $("#abuseReport")
        .modal("show")
        .on("hidden.bs.modal", function (e) {
          $("#abuseReport").remove();
        });

      $("#submit-abuse-report").click(function (e) {
        const text = $("#abuse-text").val();
        $.ajax({
          url: `/api/memorials/report-memory/`,
          type: "POST",
          data: { memory_id: memoryId, text: text },
          dataType: "json",
          beforeSend: function () {
            loader.show();
          },
          success: function (result) {
            loader.hide();
            if (result.success) {
              $this.loadList(true);
              modal.modal("hide");
            }
          },
        });
      });
    });
    $("#memories-list").on("click", ".memory-remove", async function () {
      if (!(await ensureIdaOkOrShowModal())) {
        return;
      }
      const memoryId = parseInt($(this).data("id"));

      $.ajax({
        url: `/api/memorials/delete-memory/`,
        type: "POST",
        data: { memory_id: memoryId },
        dataType: "json",
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            $this.loadList(true);
          }
        },
      });
    });
    $("#memories-list").on("click", ".submit-like", async function () {
      if (!(await ensureIdaOkOrShowModal())) {
        return;
      }
      const memoryId = parseInt($(this).data("id"));
      const likeOn = $(this).data("lon");
      const likeOff = $(this).data("loff");
      const icon = $(this).find("img");
      const iconSrc = icon.attr("src");

      $.ajax({
        url: `/api/memorials/submit-like/`,
        type: "POST",
        data: { memory_id: memoryId },
        dataType: "json",
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            if (iconSrc === likeOff) {
              icon.attr("src", likeOn);
            } else {
              icon.attr("src", likeOff);
            }
          }
        },
      });
    });
    $("#memories-list").on("click", ".memory-edit", async function () {
      if (!(await ensureIdaOkOrShowModal())) {
        return;
      }
      const memoryId = parseInt($(this).data("id"));

      $.ajax({
        url: `/api/memorials/memory/`,
        type: "POST",
        data: { memory_id: memoryId },
        dataType: "json",
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            memory.displayEditMemoryModal(result.memory);
          }
        },
      });
    });
  },
  renderMemoryTemplate: function (item) {
    const likeOff =
      "/wp-content/themes/fenix4/dist/images/icons/icon_heart-outline.svg";
    const likeOn =
      "/wp-content/themes/fenix4/dist/images/icons/icon_heart-blue.svg";
    const image_exist = item.image !== "";
    const like = item.liked > 0 ? likeOn : likeOff;
    return `
            <div class="single-obituary single-obituary--item grid-item masonry-item single-obituary__transparent">
                <div class="single-obituary__memo">
                    <div>
                        <div class="single-obituary__image" ${
                          item.edit === true ? 'style="min-height:40px;"' : ""
                        }>
                            <div class="single-obituary__image-wrapper" data-slider='["${item.gallery.join(
                              '","'
                            )}"]'>
                                <div>
                                    ${
                                      image_exist
                                        ? `<img src="${item.image}" alt="${item.name}">`
                                        : ""
                                    }
                                    <div class="single-obituary__service">
                                        ${
                                          item.edit === true
                                            ? `
                                            <button type="button" class="single-obituary__edit-wrapper memory-edit" data-id="${item.id}">
                                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_edit-blue.svg" alt="Edit icon" class="single-obituary__edit">Redigera
                                            </button>
                                            <button type="button" class="single-obituary__delete-wrapper memory-remove" data-id="${item.id}">
                                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_delete-red.svg" alt="Delete icon" class="single-obituary__delete">Radera
                                            </button>
                                        `
                                            : ""
                                        }
                                        ${
                                          image_exist
                                            ? `
                                            <div class="single-obituary__resize-wrapper" data-toggle="modal" data-target="#imgmodal">
                                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_resize-blue.svg" alt="Resize icon" class="single-obituary__resize">
                                            </div>
                                        `
                                            : ""
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="single-obituary__text">
                        <p>${item.text.replace(/(?:\r\n|\r|\n)/g, "<br>")}</p>
                        <p class="single-obituary__name">${item.name}</p>
                        <span class="single-obituary__date">${item.date}</span>
                        <div class="single-obituary__actions">
                            <button type="button" class="btn icon btn-like submit-like" data-lon="${likeOn}" data-loff="${likeOff}" data-id="${
      item.id
    }">
                                <img src="${like}" alt="Heart logo"><span>Gilla</span>
                            </button>
                            <button type="button"class="btn icon btn-share share-modal" data-toggle="modal" data-target="#shareModal">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_share-blue.svg" alt="Share logo"><span>Dela</span>
                            </button>
                            <button type="button" class="btn icon btn-report abuse-report" data-id="${
                              item.id
                            }">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_warning-blue.svg" alt="Warning logo"><span>Anmäl</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        `;
  },
};
const memory = {
  init: function () {
    this.initEvents();
  },
  initEvents: function () {
    const $this = this;

    $(".trigger-memory-modal").click(async function (e) {
      e.preventDefault();
      if (!(await ensureIdaOkOrShowModal())) {
        return;
      }
      const memorialId = parseInt($("#main").data("memorial-id"));

      $.ajax({
        url: `/api/memorials/${memorialId}/`,
        type: "POST",
        data: { id: memorialId },
        dataType: "json",
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            $this.displayMemoryModal(result.memorial);
          }
        },
      });
    });
  },
  displayMemoryModal: function (memorial) {
    const $this = this;
    $("body").append(this.renderMemoryModalTemplate(memorial));

    this.initMediaUploadButton();
    this.initInputLabels(".form-control__input", ".form-group__label");
    this.initInputLabels(".form-control__textarea", ".form-group__label");

    const memoryModal = $("#memoryModal")
      .modal("show")
      .on("hidden.bs.modal", function (e) {
        $("#memoryModal").remove();
        memoriesList.loadList(true);
      });

    $("#memory-form").validate({
      rules: {
        memory_name: {
          required: true,
        },
        memory_email: {
          required: true,
          email: true,
        },
        memory_text: {
          required: true,
        },
      },
      focusCleanup: true,
      onfocusout: false,
      onkeyup: false,
      onclick: false,
    });

    $("#memory-submit").click(async function (e) {
      if (!(await ensureIdaOkOrShowModal())) {
        return false;
      }
      if (!$("#memory-form").valid()) {
        return false;
      }

      const memorialId = parseInt($("#main").data("memorial-id"));
      const name = $("#memory_name").val();
      const text = $("#memory_text").val();
      const email = $("#memory_email").val();
      const fundUrlChecked = $("#fund-url").is(":checked");

      const fileInput = $("#media_files");
      const filesObj = fileInput.prop("files");
      const formData = new FormData();

      if (fundUrlChecked) {
        window.open($("#fund-url").data("url"), "_blank");
      }

      for (let i = 0; i < filesObj.length; i++) {
        formData.append("files[]", filesObj[i]);
      }
      formData.append("memorial_id", memorialId);
      formData.append("name", name);
      formData.append("text", text);
      formData.append("email", email);

      $.ajax({
        url: `/api/memorials/save-memory/`,
        type: "POST",
        contentType: false,
        processData: false,
        data: formData,
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            memoryModal.modal("hide");
            //$this.renderThankYouModal(memorial, email);
          }
        },
      });
    });
  },
  displayEditMemoryModal: function (memory) {
    const $this = this;
    $("body").append(this.renderEditMemoryModalTemplate(memory));

    this.initMediaUploadButton();
    this.initInputLabels(".form-control__input", ".form-group__label");
    this.initInputLabels(".form-control__textarea", ".form-group__label");

    const memoryModal = $("#memoryModal")
      .modal("show")
      .on("hidden.bs.modal", function (e) {
        $("#memoryModal").remove();
        memoriesList.loadList(true);
      });

    $("#memory-form").validate({
      rules: {
        memory_name: {
          required: true,
        },
        memory_email: {
          required: true,
          email: true,
        },
        memory_text: {
          required: true,
        },
      },
      focusCleanup: true,
      onfocusout: false,
      onkeyup: false,
      onclick: false,
    });

    $("#memory-edit").click(async function (e) {
      if (!(await ensureIdaOkOrShowModal())) {
        return false;
      }
      if (!$("#memory-form").valid()) {
        return false;
      }

      const memorialId = parseInt($("#main").data("memorial-id"));
      const name = $("#memory_name").val();
      const text = $("#memory_text").val();
      const email = $("#memory_email").val();

      const fileInput = $("#media_files");
      const filesObj = fileInput.prop("files");
      const formData = new FormData();

      for (let i = 0; i < filesObj.length; i++) {
        formData.append("files[]", filesObj[i]);
      }
      formData.append("memorial_id", memorialId);
      formData.append("memory_id", memory.id);
      formData.append("name", name);
      formData.append("text", text);
      formData.append("email", email);

      $.ajax({
        url: `/api/memorials/update-memory/`,
        type: "POST",
        contentType: false,
        processData: false,
        data: formData,
        beforeSend: function () {
          loader.show();
        },
        success: function (result) {
          loader.hide();
          if (result.success) {
            memoryModal.modal("hide");
          }
        },
      });
    });
  },
  initInputLabels: function (n, o) {
    $.each($(n), function (n, t) {
      const i = $(t);
      const e = i.siblings(o);
      i.on("blur focus", function (n) {
        i.is(":focus") || i.val()
          ? e.addClass("active-label")
          : e.removeClass("active-label");
      });
    });
  },
  initMediaUploadButton: function () {
    const fileInput = $("#media_files");
    const label = $("#media-upload span");
    fileInput.on("change", function (e) {
      const files = e.target.files;
      if (files.length < 1) {
        return false;
      }

      let fileNames = [];
      for (let i = 0; i < files.length; i++) {
        fileNames.push(files.item(i).name);
      }
      label.html(fileNames.join(", "));
    });

    $("#media-upload").click(function (e) {
      e.preventDefault();
      $(this).siblings("input[type=file]").trigger("click");
    });
  },
  renderMemoryModalTemplate: function (memorial) {
    const fund_image =
      memorial.fund && memorial.fund.image ? memorial.fund.image : "";
    const no_fund_array = [
      "No memorial fund",
      "Not decided",
      "Ej bestämt",
      "Ingen minnesfond",
      "null",
    ];
    console.log(memorial.fund);
    const no_fund_image_class = !fund_image ? "no-fund-image" : "";
    return `
        <div class="modal fade obituary-modal" id="memoryModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <form id="memory-form">
                        <div class="modal-header">
                            <h2 class="modal-title" id="exampleModalLabel">Dela ett minne </h2>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_close.svg" alt="close icon">
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="form-group">
                                        <input type="text" class="form-control form-control__input" id="memory_name" name="memory_name" autocomplete="given-name" required>
                                        <label class="form-group__label" for="memory_name">Ditt förnamn <span class="obligatory">*</span></label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <input type="file" name="media" id="media_files" class="inputfile" multiple style="display: none;"/>
                                        <button class="obituary-content__comment-upload" id="media-upload">
                                            <img src="/wp-content/themes/fenix4/dist/images/icons/icon_upload.svg" alt="Upload logo"><span>Välj bilder</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group form-group--textarea">
                                        <label class="form-group__label" for="memory_text">Dela med dig av dina minnen av ${
                                          memorial.name
                                        }, eller skriv en avskedshälsning <span class="obligatory">*</span></label>
                                        <textarea class="form-control form-control__textarea" id="memory_text" name="memory_text" rows="3" spellcheck="false" required></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="email" class="form-control form-control__input" id="memory_email" name="memory_email" autocomplete="email" required>
                                        <label class="form-group__label" for="memory_email">Din e-post <span class="obligatory">*</span></label>
                                    </div>
                                </div>
                                <div class="col-sm-6 hidden-less-576">
                                    <div class="form-group">
                                        <div class="consent-text"><small>Genom att gå vidare godkänner du att vi lagrar dina uppgifter samt skickar matnyttig information till dig. Du kan när som helst avregistrera dig från framtida utskick.</small></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="fund-row">
                                ${
                                  memorial.fund &&
                                  !no_fund_array.includes(
                                    memorial.fund.title
                                  ) &&
                                  !!memorial.fund.title
                                    ? `
                                    ${
                                      fund_image
                                        ? `<img src="${memorial.fund.image}" alt="${memorial.fund.title}">`
                                        : ``
                                    }
                                    <div class="fund-checkbox ${no_fund_image_class}">
                                        <label class="filter-box__label">
                                            <input type="checkbox" name="fund-url" id="fund-url" data-url="${
                                              memorial.fund.url
                                            }">
                                            <span class="filter-box__name">${
                                              memorial.fund.title
                                            }</span>
                                            <span class="filter-box__checkmark"></span>
                                        </label>
                                        <span class="filter-box__comment">Organisationens hemsida öppnas i en ny flik när du har delat ett minne.</span>
                                    </div>
                                `
                                    : ""
                                }
                            </div>
                            <button type="button" class="btn btn-primary btn-blue" id="memory-submit">Skicka</button>
                            <div class="consent-text show-less-576" style="display:none; margin-top:15px;"><small>Genom att gå vidare godkänner du att vi lagrar dina uppgifter samt skickar matnyttig information till dig. Du kan när som helst avregistrera dig från framtida utskick.</small></div>
                        </div>
                    </form>
                </div>
            </div>
        </div>        
        `;
  },
  renderEditMemoryModalTemplate: function (memory) {
    return `
        <div class="modal fade obituary-modal" id="memoryModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <form id="memory-form">
                        <div class="modal-header">
                            <h2 class="modal-title" id="exampleModalLabel">Redigera ett minne </h2>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_close.svg" alt="close icon">
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="form-group">
                                        <input type="text" class="form-control form-control__input" id="memory_name" name="memory_name" autocomplete="given-name" value="${
                                          memory.name
                                        }" required>
                                        <label class="form-group__label ${
                                          memory.name !== ""
                                            ? "active-label"
                                            : ""
                                        }" for="memory_name">Ditt förnamn <span class="obligatory">*</span></label>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <input type="file" name="media" id="media_files" class="inputfile" multiple style="display: none;"/>
                                        <button class="obituary-content__comment-upload" id="media-upload">
                                            <img src="/wp-content/themes/fenix4/dist/images/icons/icon_upload.svg" alt="Upload logo"><span>Välj bilder</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group form-group--textarea">
                                        <label class="form-group__label ${
                                          memory.text !== ""
                                            ? "active-label"
                                            : ""
                                        }" for="memory_text">Dela med dig av dina minnen av ${
      memory.memorial_name
    }, eller skriv en avskedshälsning <span class="obligatory">*</span></label>
                                        <textarea class="form-control form-control__textarea" id="memory_text" name="memory_text" rows="3" spellcheck="false" required>${
                                          memory.text
                                        }</textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <input type="email" class="form-control form-control__input" id="memory_email" name="memory_email" autocomplete="email" value="${
                                          memory.email
                                        }" required>
                                        <label class="form-group__label ${
                                          memory.email !== ""
                                            ? "active-label"
                                            : ""
                                        }" for="memory_email">Din e-post <span class="obligatory">*</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="fund-row"></div>
                            <button type="button" class="btn btn-primary btn-blue" id="memory-edit">Spara</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>        
        `;
  },
  // renderThankYouModal: function (memorial, email){
  //
  //     $('body').append(this.renderThankYouTemplate(memorial, email));
  //
  //     const thanksModal = $('#thanksModal').modal('show').on('hidden.bs.modal', function(e){
  //         $('#thanksModal').remove();
  //     });
  //
  //     $('#thanksModal .close').click(function (e){
  //         thanksModal.modal('hide')
  //     });
  //
  //     $("#subscribe-form").validate({
  //         rules: {
  //             subscribe_email: {
  //                 required: true,
  //                 email: true
  //             },
  //         },
  //         focusCleanup: true,
  //         onfocusout: false,
  //         onkeyup: false,
  //         onclick: false
  //     });
  //     $('#subscribe').click(function (e) {
  //         if (!$("#subscribe-form").valid()) {
  //             return false;
  //         }
  //
  //         const memorialId = parseInt($('#main').data('memorial-id'));
  //         const email = $('#subscribe_email').val();
  //
  //         $.ajax({
  //             url: `/api/memorials/subscribe/`,
  //             type: 'POST',
  //             data: {'memorial_id': memorialId, 'email': email },
  //             dataType: 'json',
  //             beforeSend: function () {
  //                 loader.show();
  //             },
  //             success: function( result ) {
  //                 loader.hide();
  //                 if (result.success){
  //                     thanksModal.modal('hide')
  //                 }
  //             }
  //         });
  //     })
  // },
  // renderThankYouTemplate: function (memorial, email = ''){
  //     return `
  //     <div class="modal fade obituary-modal" id="thanksModal" tabindex="-1" role="dialog"  aria-hidden="true">
  //         <div class="modal-dialog modal-dialog-centered" role="document">
  //             <div class="modal-content">
  //                 <form id="subscribe-form">
  //                 <div class="modal-header">
  //                     <div></div>
  //                     <button type="button" class="close" data-dismiss="modal" aria-label="Close">
  //                         <img src="/wp-content/themes/fenix4/dist/images/icons/icon_close.svg" alt="close icon">
  //                     </button>
  //                 </div>
  //                 <div class="modal-body">
  //                     <div class="modal-body__icon">
  //                         <img class="modal-body__icon" src="/wp-content/themes/fenix4/dist/images/icon-flower-blue.svg" alt="Flower icon">
  //                     </div>
  //                     <div class="modal-body__abuse-title">Tack för att du delade ett minne av ${memorial.name}</div>
  //                     <div class="copy-share__link">Ange din e-mail för att få andras minnen skickade till dig.</div>
  //                 </div>
  //                 <div class="modal-footer">
  //                     <input type="email" name="subscribe_email" id="subscribe_email" placeholder="Din e-post" value="${email}">
  //                     <button type="button" class="btn btn-primary btn-blue" id="subscribe">Skicka</button>
  //                 </div>
  //                 </form>
  //             </div>
  //         </div>
  //     </div>
  //     `;
  // }
};
const share = {
  init: function () {
    this.initEvents();
  },
  initEvents: function () {
    const $this = this;

    $("#delaMinnessidan").click(function (e) {
      $this.displayShareModal();
    });

    $("#memories-list").on("click", ".share-modal", function () {
      $this.displayShareModal();
    });
  },
  initCopyEvent: function () {
    const $this = this;

    let copyTimeoutId;
    $("#copyButton").click(function (e) {
      clearTimeout(copyTimeoutId);
      $(".clipboard-input-success").remove();

      $this.copyToClipboard(document.getElementById("clipboardLink"));

      $("#clipboard-input-wrapper").append(
        '<div class="clipboard-input-success"><div>Länken har nu kopierats</div></div>'
      );
      $(".clipboard-input-success").fadeIn(200);
      copyTimeoutId = setTimeout(function () {
        $(".clipboard-input-success").fadeOut(200, function () {
          $(this).remove();
        });
      }, 2000);
    });
  },
  copyToClipboard: function (elem) {
    // create hidden text element, if it doesn't already exist
    var targetId = "_hiddenCopyText_";
    var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
    var origSelectionStart, origSelectionEnd;
    if (isInput) {
      // can just use the original source element for the selection and copy
      target = elem;
      origSelectionStart = elem.selectionStart;
      origSelectionEnd = elem.selectionEnd;
    } else {
      // must use a temporary form element for the selection and copy
      target = document.getElementById(targetId);
      if (!target) {
        var target = document.createElement("textarea");
        target.style.position = "absolute";
        target.style.left = "-9999px";
        target.style.top = "0";
        target.id = targetId;
        document.body.appendChild(target);
      }
      target.textContent = elem.textContent;
    }
    // select the content
    var currentFocus = document.activeElement;
    target.focus();
    target.setSelectionRange(0, target.value.length);

    // copy the selection
    var succeed;
    try {
      succeed = document.execCommand("copy");
    } catch (e) {
      succeed = false;
    }
    // restore original focus
    if (currentFocus && typeof currentFocus.focus === "function") {
      currentFocus.focus();
    }

    if (isInput) {
      // restore prior selection
      elem.setSelectionRange(origSelectionStart, origSelectionEnd);
    } else {
      // clear temporary content
      target.textContent = "";
    }
    return succeed;
  },
  displayShareModal: function () {
    const url = window.location;
    const text = `Till minne av ${$("h1.obituary__name").html()}`;
    const tpl = `
            <div class="modal fade obituary-modal" id="shareModal" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div></div>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <img src="/wp-content/themes/fenix4/dist/images/icons/icon_close.svg" alt="close icon">
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="modal-body__icon">
                                <img class="modal-body__icon" src="/wp-content/themes/fenix4/dist/images/icons/icon_candle-holder.svg" alt="Candle holder icon">
                            </div>
            
                            <div class="modal-body__abuse-title">Dela denna sida</div>
                            <div class="share-wrapper">
                                <a href="https://www.facebook.com/sharer/sharer.php?u=${url}" target="_blank" rel="noopener">
                                    <button type="button" id="shareFacebookBtn" class="share-facebook"><img src="/wp-content/themes/fenix4/dist/images/icons/icon_facebook-white.svg" alt="Facebook logo">Facebook</button>
                                </a>
                            </div>
                            <hr />
                            <div class="copy-share__link">Du kan även kopiera & dela länken:</div>
                        </div>
                        <div class="modal-footer">
                            <div id="clipboard-input-wrapper">
                                <input type="text" id="clipboardLink" value="${url}">
                            </div>
                            <button id="copyButton" type="button" class="btn btn-primary btn-blue">Kopiera</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

    $("body").append(tpl);
    this.initCopyEvent();

    $("#shareModal")
      .modal("show")
      .on("hidden.bs.modal", function (e) {
        $("#shareModal").remove();
      });
  },
};
const products = {
  loadMoreButton: $("#moreProducts"),
  init: function () {
    this.initEvents();
  },
  initEvents: function () {
    const $this = this;

    $this.loadMoreButton.click(function () {
      if ($(this).hasClass("disabled")) {
        return false;
      }

      $this.updateLoadMoreButton();
      $this.loadItems();
    });
  },
  disableLoadMoreButton: function () {
    this.loadMoreButton.addClass("disabled").hide();
  },
  updateLoadMoreButton: function () {
    const page = parseInt(this.loadMoreButton.data("page"), 10);
    this.loadMoreButton.data("page", page + 1);
  },
  loadItems: function () {
    const $this = this;
    const wrapper = $("#productsList");
    const categoryId = parseInt($this.loadMoreButton.data("category"));
    const categoryExcludeId = parseInt(
      $this.loadMoreButton.data("category-exclude")
    );

    let filter = {
      page: $this.loadMoreButton.data("page"),
      categoryId: categoryId,
      categoryExcludeId: categoryExcludeId,
    };

    $.ajax({
      url: `/api/products/category-widget/`,
      type: "POST",
      data: filter,
      dataType: "json",
      beforeSend: function () {
        loader.show();
      },
      success: function (result) {
        loader.hide();
        if (result.success) {
          wrapper.append(result.html);

          if (result.nextPage === false) {
            $this.disableLoadMoreButton();
          }
        }
      },
    });
  },
};
const loadImages = (src) => {
  "use strict";

  const paths = Array.isArray(src) ? src : [src];
  const promises = [];

  paths.forEach((path) => {
    promises.push(
      new Promise((resolve, reject) => {
        const img = new Image();

        img.onload = () => resolve(path);
        img.onerror = () => reject(path);

        img.src = path;
      })
    );
  });

  return Promise.allSettled(promises);
};

$(document).ready(function () {
  // START Anmalan form
  dublicateDietRow();
  jQuery.validator.addMethod(
    "emailcheck",
    function (value, element) {
      return (
        this.optional(element) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)
      );
    },
    "Vänligen ange rätt e-postadress"
  );
  $("#funeralFormSubmit").click(async function (e) {
    e.preventDefault();
    var $this = $(this);

    if (!$("#select-funeral").val()) {
      $("#addinfoname-error").show();
      scrollToFormTop($(".memory-notification-wrapper"));
    } else {
      if ($("#rsvpForm").valid()) {
        if (!(await ensureIdaOkOrShowModal())) {
          return;
        }
        $.ajax({
          url: `/api/memorials/submit-registration/`,
          type: "POST",
          // contentType: false,
          // processData: false,
          data: $("#rsvpForm").serialize(),
          beforeSend: function () {
            loader.show();
            $this.prop("disabled", true);
          },
          success: function (data) {
            loader.hide();
            $(".form-error").remove();
            if (data.status === "success") {
              $("#rsvp-thanks").show();
              $("#rsvpForm").hide();
            } else if (data.status === "error") {
              $this
                .closest(".justify-content-end")
                .append(
                  `<div class="col-12 form-error"><div class="alert alert-danger">${data.message}</div></div>`
                );
            }
          },
          complete: function () {
            $this.prop("disabled", false);
          },
        });
      }
    }
  });
  $("#rsvpForm").validate({
    rules: {
      funeral: "required",
      namn: {
        required: true,
        lettersonly: true,
      },
      fornamn: {
        required: true,
        lettersonly: true,
      },
      email: {
        required: false,
        emailcheck: true,
      },
      telefonnummer: {
        required: true,
        fenixSEPhone: true,
      },
      angeantal: {
        required: false,
        digits: true,
        min: 0,
      },
      allergier: "required",
      jag: "required",
    },
    focusCleanup: true,
    onfocusout: false,
    onkeyup: false,
    onclick: false,
  });
  $("#rsvpReset").click(function () {
    $("#rsvpForm")[0].reset();

    $("#diet-rows-wrapper > div").each(function (index, val) {
      $(val).remove();
    });
    dublicateDietRow();
  });
  $("#diet-rows-wrapper").on("click", ".remove-diet-row", function (e) {
    e.preventDefault();
    var rows = $("#diet-rows-wrapper > div").length;
    var currentRow = $(this).closest(".row");

    if (rows > 1) {
      currentRow.remove();
    }

    reassignInputIndexes();
  });
  function dublicateDietRow() {
    var rows = $("#diet-rows-wrapper > div").length;

    var el = $(".diet-template")
      .clone(true)
      .removeClass("diet-template")
      .css("display", "flex")
      .appendTo("#diet-rows-wrapper");
    el.find(".food-restrictions-name").attr(
      "name",
      `food-restrictions[${rows}][name]`
    );
    el.find(".food-restrictions-value").attr(
      "name",
      `food-restrictions[${rows}][value]`
    );
    el.find(".food-restrictions-ppl").attr(
      "name",
      `food-restrictions[${rows}][ppl]`
    );

    try {
      Choices.prototype._onEnterKey = function (
        event,
        activeItems,
        hasActiveDropdown
      ) {
        event.preventDefault();
        return false;
      };
      var selectEl = el.find(".food-restrictions")[0];
      var select = new Choices(selectEl, {
        removeItems: true,
        silent: true,
        removeItemButton: true,
        placeholder: true,
        searchPlaceholderValue: $(selectEl).attr("placeholder"),
        itemSelectText: "",
        noResultsText: "Tryck på Enter för att lägga till ett valfritt",
      });
      const choicesIssue39Fix = (choicesElement) => {
        choicesElement.input.element.addEventListener(
          "keydown",
          (keypressEvent) => {
            if (keypressEvent.keyCode === 13 && keypressEvent.target.value) {
              keypressEvent.stopPropagation();
              choicesElement.setChoices(
                [
                  {
                    value: keypressEvent.target.value,
                    label: keypressEvent.target.value,
                    selected: true,
                  },
                ],
                "value",
                "label",
                false
              );
              const linterEvent = keypressEvent;
              linterEvent.target.value = "";

              var values = select.getValue();
              $(selectEl)
                .closest(".choices")
                .next("input.food-restrictions-value")
                .attr(
                  "value",
                  values ? values.map((el) => el.value).join(",") : ""
                )
                .next("input.food-restrictions-name")
                .attr(
                  "value",
                  values ? values.map((el) => el.label).join(",") : ""
                );

              var rows = $("#diet-rows-wrapper > div").length;
              if ((!$(selectEl).data("created") || rows === 1) && values) {
                dublicateDietRow();
              }
              $(selectEl).data("created", 1);

              if (values.length !== 0) {
                $(selectEl).siblings("input").attr("placeholder", "");
              }
            }
          }
        );
      };
      choicesIssue39Fix(select);
      selectEl.addEventListener(
        "change",
        function (e) {
          var values = select.getValue();

          var rows = $("#diet-rows-wrapper > div").length;
          $(this)
            .closest(".choices")
            .next("input.food-restrictions-value")
            .attr("value", values ? values.map((el) => el.value).join(",") : "")
            .next("input.food-restrictions-name")
            .attr(
              "value",
              values ? values.map((el) => el.label).join(",") : ""
            );
          if ((!$(this).data("created") || rows === 1) && values) {
            dublicateDietRow();
          }
          $(this).data("created", 1);

          var pplEl = el.find(".food-restrictions-ppl");
          if (!pplEl.val()) {
            pplEl.attr("value", 1);
          }

          if (values.length === 0) {
            pplEl.attr("value", "");
            $(this)
              .siblings("input")
              .attr("placeholder", $(this).data("placeholder"))
              .css("width", "auto");
          } else {
            $(this).siblings("input").attr("placeholder", "");
          }
        },
        false
      );
    } catch (e) {}
  }
  function scrollToFormTop(el, offset) {
    if (offset === undefined) {
      offset = 0;
    }
    if ($(window).width() > 575) {
      offset = -110;
    }

    var objToScroll = el;
    setTimeout(function () {
      $("html, body")
        .delay(10)
        .animate({ scrollTop: objToScroll.offset().top + offset }, 400);
    }, 300);
  }
  function reassignInputIndexes() {
    $("#diet-rows-wrapper .food-restrictions-name").each(function (ind, el) {
      $(this).attr("name", `food-restrictions[${ind}][name]`);
    });
    $("#diet-rows-wrapper .food-restrictions-value").each(function (ind, el) {
      $(this).attr("name", `food-restrictions[${ind}][value]`);
    });
    $("#diet-rows-wrapper .food-restrictions-ppl").each(function (ind, el) {
      $(this).attr("name", `food-restrictions[${ind}][ppl]`);
    });
  }
  // END ANMALAN form

  $(".obituary-single__list-item")
    .on("mouseenter", function () {
      $(this)
        .find("img")
        .tooltip({
          template:
            '<div class="tooltip obituary-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
          offset: "0,2px",
        })
        .tooltip("show");
    })
    .on("mouseleave", function () {
      $(this).find("img").tooltip("hide");
    });

  memoriesList.init();
  memory.init();
  share.init();
  products.init();

  /**
   * Onpage sticky navigation for individual memory page
   */
  const masthead = document.getElementById("masthead");
  const obituaryStickyNav = document.getElementById("obituary-sticky");
  const commentsInfo = document.getElementById("comments-info");

  if (masthead && obituaryStickyNav && commentsInfo) {
    $(window).on("load resize", function () {
      let stickNowPos =
        commentsInfo.offsetTop -
        obituaryStickyNav.offsetHeight -
        masthead.offsetHeight;

      // stick if page reloaded already scrolled down:
      stickOnpageNav();

      window.onscroll = function () {
        stickOnpageNav();
      };

      function stickOnpageNav() {
        if (window.pageYOffset >= stickNowPos) {
          if (!obituaryStickyNav.classList.contains("sticky-nav")) {
            obituaryStickyNav.classList.add("sticky-nav");
          }
        } else {
          if (obituaryStickyNav.classList.contains("sticky-nav")) {
            obituaryStickyNav.classList.remove("sticky-nav");
          }
        }
      }
    });
  }

  $(".scroll-link").click(function (e) {
    e.preventDefault();

    const href = $(this).attr("href");
    scrollToElement(href);
  });

  $("#skrivHalsning").click(function (e) {
    scrollToElement("#add-comment");
  });

  function scrollToElement(href) {
    const el = $(href);
    let offset = undefined;

    let headerHeight = $("#masthead").height();
    if ($("#obituary-sticky:not(.sticky-nav)").length) {
      headerHeight += $("#obituary-sticky:not(.sticky-nav)").height();
    }

    if (href === "#rsvp-info") {
      offset =
        $(".js-tweak-mob-offset").height() > 34
          ? headerHeight + 60
          : headerHeight;
    }

    let onpageNavOffsetMem = headerHeight - 1;
    if (offset === undefined) {
      offset = onpageNavOffsetMem;
    }

    $("html, body").animate({ scrollTop: el.offset().top - offset }, 400);
    return false;
  }
});
